import { useTranslation } from "react-i18next";

import LegalLayout from "./LegalLayout.jsx";
import LegalSections from "./LegalSections.jsx";
import { OFFER_CONTENT } from "./content/offer.js";

export default function Offer() {
  const { i18n, t } = useTranslation();
  const lang = i18n.language && OFFER_CONTENT[i18n.language]
    ? i18n.language
    : (i18n.language?.split("-")[0] || "uk");
  const content = OFFER_CONTENT[lang] || OFFER_CONTENT.uk;

  return (
    <LegalLayout
      title={content.title}
      lastUpdated={t("legal.lastUpdated", { date: content.lastUpdated })}
    >
      <p>{content.intro}</p>
      <LegalSections sections={content.sections} />
    </LegalLayout>
  );
}
